import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'shared/styles/modern-theme.css';

import PageLoader from 'shared/components/PageLoader';
import { LanguageProvider, useLanguage } from 'shared/context/LanguageContext';
import { OnboardingProvider, OnboardingPage, LandingPage } from 'features/onboarding';
import {
  PartnerAuthProvider,
  PartnerLoginPage,
  PartnerProtectedRoute,
} from 'features/partner-auth';
import { PortalLayout, PortalPage } from 'features/partner-portal';
import ErrorBoundary from 'app/ErrorBoundary';

const ToastBridge: React.FC = () => {
  const { dir } = useLanguage();
  return (
    <ToastContainer
      position="top-center"
      autoClose={2500}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={dir === 'rtl'}
      style={{ zIndex: 99999 }}
    />
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LanguageProvider>
          <PartnerAuthProvider>
            <OnboardingProvider>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/register" element={<OnboardingPage />} />
                  <Route
                    path="/onboarding"
                    element={<Navigate to="/register" replace />}
                  />
                  <Route path="/login" element={<PartnerLoginPage />} />
                  <Route element={<PartnerProtectedRoute />}>
                    <Route path="/portal" element={<PortalLayout />}>
                      <Route index element={<PortalPage />} />
                      <Route path="status" element={<PortalPage />} />
                    </Route>
                  </Route>
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
              <ToastBridge />
            </OnboardingProvider>
          </PartnerAuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
